const national = [

  {
    id: "independence-day-india",
    date: "08-15",
    category: "national",
    title: "Indian Independence Day",
    description: `India celebrates Independence Day to commemorate 
    freedom from British rule in 1947. 
    The day honors the sacrifices of freedom fighters 
    and celebrates national unity and pride.`,
    color: "#FF6F00"
  },
  {
    id: "republic-day",
    date: "01-26",
    category: "national",
    title: "Republic Day",
    description: `Republic Day marks the adoption of the Constitution of India in 1950. It celebrates India's democratic values, sovereignty, and constitutional governance.`,
    color: "#FF6B35"
  },

  {
    id: "martyrs-day",
    date: "01-30",
    category: "national",
    title: "Martyrs' Day",
    description: `Observed in memory of Mahatma Gandhi and freedom fighters who sacrificed their lives for the nation. It honors their courage and commitment to India’s independence.`,
    color: "#6B7280"
  },

  {
    id: "national-science-day",
    date: "02-28",
    category: "national",
    title: "National Science Day",
    description: `Celebrated to mark Sir C.V. Raman's discovery of the Raman Effect. It promotes scientific temper, research, and innovation across India.`,
    color: "#2563EB"
  },

  {
    id: "national-womens-day-india",
    date: "02-13",
    category: "national",
    title: "National Women's Day (India)",
    description: `Observed on the birth anniversary of Sarojini Naidu. It honors women's leadership, empowerment, and contributions to the nation.`,
    color: "#DB2777"
  },

  {
    id: "national-youth-day",
    date: "01-12",
    category: "national",
    title: "National Youth Day",
    description: `Celebrated on Swami Vivekananda’s birth anniversary. It inspires young citizens to lead with strength, vision, and service.`,
    color: "#F59E0B"
  },

  {
    id: "army-day",
    date: "01-15",
    category: "national",
    title: "Indian Army Day",
    description: `Honors the bravery and dedication of the Indian Army. It commemorates the appointment of the first Indian Commander-in-Chief in 1949.`,
    color: "#15803D"
  },

  {
    id: "navy-day",
    date: "12-04",
    category: "national",
    title: "Indian Navy Day",
    description: `Recognizes the strength and maritime security role of the Indian Navy. It commemorates Operation Trident during the 1971 war.`,
    color: "#1E40AF"
  },

  {
    id: "air-force-day",
    date: "10-08",
    category: "national",
    title: "Indian Air Force Day",
    description: `Celebrates the establishment of the Indian Air Force. It honors air warriors for safeguarding India’s skies.`,
    color: "#0EA5E9"
  },

  {
    id: "national-doctors-day-india",
    date: "07-01",
    category: "national",
    title: "National Doctors' Day (India)",
    description: `Observed in honor of Dr. B.C. Roy. It recognizes the dedication and service of medical professionals across the country.`,
    color: "#DC2626"
  },

  {
    id: "national-teachers-day-india",
    date: "09-05",
    category: "national",
    title: "Teachers' Day (India)",
    description: `Celebrated on Dr. Sarvepalli Radhakrishnan’s birth anniversary. It honors educators for shaping the nation’s future.`,
    color: "#7C3AED"
  },

  {
    id: "gandhi-jayanti",
    date: "10-02",
    category: "national",
    title: "Gandhi Jayanti",
    description: `Commemorates the birth anniversary of Mahatma Gandhi. It promotes peace, non-violence, and truth.`,
    color: "#4B5563"
  },

  {
    id: "national-unity-day",
    date: "10-31",
    category: "national",
    title: "National Unity Day",
    description: `Observed on Sardar Vallabhbhai Patel’s birth anniversary. It reinforces national integration and unity.`,
    color: "#EA580C"
  },

  {
    id: "constitution-day-india",
    date: "11-26",
    category: "national",
    title: "Constitution Day",
    description: `Marks the adoption of the Indian Constitution in 1949. It highlights constitutional values and citizens’ rights.`,
    color: "#0F766E"
  },

  {
    id: "kargil-vijay-diwas",
    date: "07-26",
    category: "national",
    title: "Kargil Vijay Diwas",
    description: `Commemorates India’s victory in the Kargil War of 1999. It honors the bravery of soldiers who defended the nation.`,
    color: "#B91C1C"
  },

  {
    id: "national-voters-day",
    date: "01-25",
    category: "national",
    title: "National Voters' Day",
    description: `Encourages citizens to participate in the democratic process. It promotes awareness about voting rights.`,
    color: "#9333EA"
  },

  {
    id: "national-sports-day",
    date: "08-29",
    category: "national",
    title: "National Sports Day",
    description: `Celebrated on Major Dhyan Chand’s birth anniversary. It promotes sportsmanship and athletic excellence.`,
    color: "#16A34A"
  },

  {
    id: "national-technology-day",
    date: "05-11",
    category: "national",
    title: "National Technology Day",
    description: `Marks India’s technological achievements including the 1998 Pokhran tests. It celebrates innovation and scientific progress.`,
    color: "#1D4ED8"
  },

  {
    id: "national-legal-services-day",
    date: "11-09",
    category: "national",
    title: "National Legal Services Day",
    description: `Promotes free legal aid and access to justice. It reinforces citizens’ awareness of legal rights.`,
    color: "#374151"
  },

  {
    id: "national-education-day",
    date: "11-11",
    category: "national",
    title: "National Education Day",
    description: `Observed on Maulana Abul Kalam Azad’s birth anniversary. It emphasizes education as a foundation of development.`,
    color: "#0284C7"
  },

  {
    id: "subhas-chandra-bose-jayanti",
    date: "01-23",
    category: "national",
    title: "Netaji Subhas Chandra Bose Jayanti",
    description: `Celebrates the birth anniversary of Netaji Subhas Chandra Bose. It honors his leadership and patriotism.`,
    color: "#9A3412"
  }

];

export default national;